import { render, staticRenderFns } from "./Redirect.vue?vue&type=template&id=2900866f&scoped=true"
import script from "./Redirect.vue?vue&type=script&lang=js"
export * from "./Redirect.vue?vue&type=script&lang=js"
import style0 from "./Redirect.vue?vue&type=style&index=0&id=2900866f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2900866f",
  null
  
)

export default component.exports